import { render, staticRenderFns } from "./expertTableView.vue?vue&type=template&id=44dc5447&scoped=true"
import script from "./expertTableView.vue?vue&type=script&lang=js"
export * from "./expertTableView.vue?vue&type=script&lang=js"
import style0 from "./expertTableView.vue?vue&type=style&index=0&id=44dc5447&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc5447",
  null
  
)

export default component.exports